import { UnpagedListResource, createApiResource } from '../apiResourceFactory';
import { PoolBrainAPI } from '../apiService';
import { PoolBrainCustomerLocationDTO, PoolBrainCustomerLocationListParams } from '../apiTypes.shim';

interface PoolBrainCustomerLocationsResource
  extends UnpagedListResource<PoolBrainCustomerLocationDTO, PoolBrainCustomerLocationListParams> {}

export const createPoolBrainCustomerLocationsResource = (companyId: string): PoolBrainCustomerLocationsResource => {
  const customerLocationResourceUri = `${companyId}/customer-locations`;

  const { useUnpagedList, unpagedList, unpagedListQueryKey } = createApiResource(
    PoolBrainAPI,
    customerLocationResourceUri
  );
  return {
    useUnpagedList,
    unpagedList,
    unpagedListQueryKey
  };
};
